module.exports = shared.LocalStorageFallback;